/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';
import React from 'react';

import { linkedAdjustmentsShape } from '../../../../../common/components/proptypes/commonProptypes';
import AdjustmentGroup from './AdjustmentGroup';

const AdjustmentGroupForMode = ({
  projectId,
  documentCode,
  contentId,
  contentVersionNumber,
  group,
  groupName,
  timePeriods,
  ebitdaContributions,
  workingCapitalContributions,
  totalOverrideValue,
  linkedAdjustments,
  showToggles,
  adjustmentToggles,
  isLastGroup,
  showTotalRow,
  targetAdjustmentType,
  targetAdjustmentName,
  nameOfAdjustmentToExpand,
  isPublishMode,
  isEditMode,
  adjustmentOptions,
  targetDocumentOptions,
  selectedLinkedAdjustments,
  setFieldValue,
  showLinkedAdjustments,
  isClientView,
}) => {
  const linkedAdjustmentsForMode = isPublishMode ? [] : linkedAdjustments;
  const showTogglesForMode = isPublishMode ? false : showToggles;
  const adjustmentTogglesForMode = isPublishMode ? {} : adjustmentToggles;

  return (
    <AdjustmentGroup
      projectId={projectId}
      documentCode={documentCode}
      contentId={contentId}
      contentVersionNumber={contentVersionNumber}
      group={group}
      groupName={groupName}
      timePeriods={timePeriods}
      ebitdaContributions={ebitdaContributions}
      workingCapitalContributions={workingCapitalContributions}
      linkedAdjustments={linkedAdjustmentsForMode}
      totalOverrideValue={totalOverrideValue}
      showToggles={showTogglesForMode}
      adjustmentToggles={adjustmentTogglesForMode}
      isLastGroup={isLastGroup}
      showTotalRow={showTotalRow}
      targetAdjustmentType={targetAdjustmentType}
      targetAdjustmentName={targetAdjustmentName}
      nameOfAdjustmentToExpand={nameOfAdjustmentToExpand}
      isPublishMode={isPublishMode}
      isEditMode={isEditMode}
      adjustmentOptions={adjustmentOptions}
      targetDocumentOptions={targetDocumentOptions}
      selectedLinkedAdjustments={selectedLinkedAdjustments}
      setFieldValue={setFieldValue}
      showLinkedAdjustments={showLinkedAdjustments}
      isClientView={isClientView}
    />
  );
};

AdjustmentGroupForMode.propTypes = {
  projectId: PropTypes.string.isRequired,
  documentCode: PropTypes.string.isRequired,
  contentId: PropTypes.number.isRequired,
  contentVersionNumber: PropTypes.number.isRequired,
  group: PropTypes.object.isRequired,
  groupName: PropTypes.string.isRequired,
  timePeriods: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  ebitdaContributions: PropTypes.object,
  workingCapitalContributions: PropTypes.object,
  totalOverrideValue: PropTypes.string,
  linkedAdjustments: PropTypes.arrayOf(linkedAdjustmentsShape),
  showToggles: PropTypes.bool,
  adjustmentToggles: PropTypes.object,
  isLastGroup: PropTypes.bool,
  showTotalRow: PropTypes.bool,
  targetAdjustmentType: PropTypes.string,
  targetAdjustmentName: PropTypes.string,
  nameOfAdjustmentToExpand: PropTypes.string,
  isPublishMode: PropTypes.bool,
  isClientView: PropTypes.bool.isRequired,
};

AdjustmentGroupForMode.defaultProps = {
  ebitdaContributions: {},
  workingCapitalContributions: {},
  totalOverrideValue: undefined,
  linkedAdjustments: [],
  showToggles: true,
  adjustmentToggles: {},
  isLastGroup: false,
  showTotalRow: true,
  targetAdjustmentType: null,
  targetAdjustmentName: null,
  nameOfAdjustmentToExpand: null,
  isPublishMode: false,
};

export default AdjustmentGroupForMode;
